import React from "react";
import { useSelector } from "react-redux";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";
import Widget from "../../../../shared/components/features/widget/Widget";
import Icon from "../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./SubmissionBoxWidget.module.css";

const SubmissionBoxWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const general = useSelector(state => state.uiData?.general);

    return (
        <Widget
            color="#F2F4F6"
            width={172}
            height={100}
            className={classes.SubmissionBoxWidget}
            title={texts.faceToFace}
        >
            <NavigateLink link={general?.FinalProject?.portalStudentLink}>
                <div className={classes.SubmissionBoxContent}>
                    <div className={classes.SubmissionBoxHeader}>
                        <Icon name={iconsList.directInbox} size="32px" className={classes.DownloadIcon} />
                        <span className={classes.SubmissionBoxText}>{texts.toSubmissionBox}</span>
                    </div>
                    <div className={classes.SubmissionDescription}>
                        <p className={classes.DescriptionText}>{texts.submissionForPresentation}</p>
                        <p className={classes.DeadlineText}>{texts.submissionDeadlineBeforeInvitation}</p>
                    </div>
                </div>
            </NavigateLink>
        </Widget>
    );
};

export default SubmissionBoxWidget;

